import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-user-registration-redirect',
  template: '',
  standalone: true,
})
export class UserRegistrationRedirectComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['invitationId']) {
        this.router.navigate(['welcome'], { queryParams: { invitationId: params['invitationId'] } });
      } else {
        this.router.navigate(['/']);
      }
    });
  }
}
